import React from "react";

import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useHistory
} from "react-router-dom";

import EditDrawer from './components/EditDrawer';

const Routes = () => {
  const history = useHistory();
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/new`} render={() => (
        <EditDrawer
          visible={true}
          closeFunction={() => history.push(`${path}`)}
        />
      )} />
      <Route exact path={`${path}/edit/:id`} render={() => (
        <EditDrawer
          visible={true}
          closeFunction={() => history.push(`${path}`)}
          edit
        />
      )} />
      <Redirect to={`${path}`} />
    </Switch>
  );
}

export default Routes;
